import type { CustomerAccessRepository } from '#/domain/customerAccess/CustomerAccessRepository'

export class GrantCustomerFeatureUseCase {
  constructor(private readonly repository: CustomerAccessRepository) {}

  execute(customerId: string, featureId: string): Promise<void> {
    return this.repository.grantFeature(customerId, featureId)
  }
}
